import { beginEditingLayoutsResolver } from './beginEditingLayoutsResolver'
import { endEditingLayoutsResolver } from './endEditingLayoutsResolver'
import { saveLayoutsResolver } from './saveLayoutsResolver'
import { tempSaveLayoutsResolver } from './tempSaveLayoutsResolver'
import { type MutationResolvers } from '../../../../generated/graphql'

export const layoutsMutations: MutationResolvers = {
    beginEditingLayouts: beginEditingLayoutsResolver,
    endEditingLayouts: endEditingLayoutsResolver,
    saveLayouts: saveLayoutsResolver,
    tempSaveLayouts: tempSaveLayoutsResolver,
}
